export default __webpack_public_path__ + "static/media/org-phone.7618ae24.svg";